import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { map, catchError } from "rxjs/operators";
import { InstanceService } from "./instance.service";

@Injectable()
export class AuthenticationService {

    get appCenterUrl(): string {
        return this.instanceService.appCenterUrl
            ? "https://" + this.instanceService.appCenterUrl.replace("http://", "").replace("https://", "")
            : "/home";
    }

    get execEndpoint(): string {
        return this.instanceService.appCenterEndpoint
            ? "https://" + this.instanceService.appCenterEndpoint.replace("http://", "").replace("https://", "")
            : "";
    }

    get globalSessionId(): string {
       return  this.cookieService.check("app-center-sessionId") &&
        this.cookieService.get("app-center-sessionId") !== ""
        ? this.cookieService.get("app-center-sessionId")
        : "";
    }

    constructor(
        private instanceService: InstanceService,
        private router: Router,
        private http: HttpClient,
        private cookieService: CookieService
    ) { }

    execObservable(command: string, params: object, commandType: string) {
        const data: object = {};
        const cmdObj: object = {};

        let header = "cmd";

        data["command"] = command;
        data["params"] = params;

        if (this.globalSessionId !== "") {
            cmdObj["auth"] = {
                sessionId: this.globalSessionId
            };
        }
        if (command === "api.authenticate") {
            header = "auth";
        }

        cmdObj[header] = data;

        return this.http
            .post(this.execEndpoint, cmdObj, {});
    }

    logout() {
        this.cookieService.delete("app-center-sessionId", "/");
    }
}
